export const primaryBrandColorVarName = '--primary-brand-color';
export const secondaryBrandColorVarName = '--secondary-brand-color';
export const tertiaryBrandColorVarName = '--tertiary-brand-color';
export const primaryBrandFontColorVarName = '--primary-brand-font-color';
